module.exports = __webpack_public_path__ + "media/step8_Kernaufgaben_animation.e60bb03a.webm";